import IframeResizer from '@rio-cloud/iframe-resizer';

export const FeedbackPage = () => (
    <div className='padding-20'>
        <IframeResizer
            title='RIO contact form'
            src='https://contact-form.rio.cloud/contact?opener=https%3A%2F%2Frental.logistic-network.rio.cloud%2F'
            allowedOrigins='any'
            className='unstyled min-width-100pct'
            style={{ height: '600px' }}
        />
    </div>
);
